import {
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

const AdminGeneralWorks: React.FC<any> = ({ param, handleChanges }) => {
  const { t } = useTranslation("common");
  return (
    <div>
      <Typography variant="h4">{t("admin.params.works.title")}</Typography>
      <Typography>{t("admin.params.works.text")}</Typography>
      <FormGroup>
        <FormControlLabel
          value={param.skills}
          onChange={(e: any) =>
            handleChanges({ ...param, skills: e.target.checked })
          }
          control={<Checkbox checked={param.skills} />}
          label={t("tests.skills")}
        />
        <FormControlLabel
          value={param.personality}
          onChange={(e: any) =>
            handleChanges({ ...param, personality: e.target.checked })
          }
          control={<Checkbox checked={param.personality} />}
          label={t("tests.b5")}
        />
        <FormControlLabel
          value={param.motivations}
          onChange={(e: any) =>
            handleChanges({ ...param, motivations: e.target.checked })
          }
          control={<Checkbox checked={param.motivations} />}
          label={t("tests.cf")}
        />
        <FormControlLabel
          value={param.dynamics}
          onChange={(e: any) =>
            handleChanges({ ...param, dynamics: e.target.checked })
          }
          control={<Checkbox checked={param.dynamics} />}
          label={t("tests.inc")}
        />
        <Typography sx={{ mt: 1 }} textAlign="right">
          {t("admin.params.reco_text")}
        </Typography>
      </FormGroup>
    </div>
  );
};

export default AdminGeneralWorks;
